import React from "react";
import dayjs from "dayjs";

function PerfilDetalleComponents({
    handleCancelar,
    dataUsuario,
    dataResumen,
    dataGiftCard,
    transacciones,

    onPageChange,
    perPage = 5,
    onPerPageChange,
}) {
    const cuponesSorteos = dataUsuario?.cupones_sorteos || [];
    const giftcardsCompradas = dataUsuario?.giftcards_compradas || [];
    const giftcardsRecibidas = dataUsuario?.giftcards_recibidas || [];
    const giftcardsCanjes = dataGiftCard?.data || [];

    const EmptyState = ({ message }) => (
        <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-500">
            {message}
        </div>
    );

    const formatDate = (value) => {
        if (!value) return "-";
        return dayjs(value).isValid() ? dayjs(value).format("DD/MM/YYYY") : "-";
    };

    const parseJsonSafe = (value) => {
        if (!value || typeof value !== "string") return null;
        try {
            return JSON.parse(value);
        } catch (error) {
            return null;
        }
    };

    const formatAmount = (amount, currency) => {
        if (amount === null || amount === undefined || amount === "") return "-";
        const numberValue = Number(amount);
        if (Number.isNaN(numberValue)) return `${amount} ${currency || ""}`.trim();
        return `${numberValue.toLocaleString("es-PY")} ${currency || ""}`.trim();
    };

    const formatNumber = (value) => {
        if (value === null || value === undefined || value === "") return "-";
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) return value;
        return numberValue.toLocaleString("es-PY");
    };

    const formatDateTime = (value) => {
        if (!value) return "-";
        return dayjs(value).isValid() ? dayjs(value).format("DD/MM/YYYY HH:mm") : "-";
    };

    const segmentoClasses = {
        activo: "bg-emerald-50 text-emerald-700 border-emerald-200",
        inactivo: "bg-gray-100 text-gray-700 border-gray-300",
        potencial: "bg-amber-50 text-amber-700 border-amber-200",
    };

    return (
        <div className="bg-white rounded-xl border border-gray-200 p-5">
            <div className="space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Nombre:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.user?.first_name} {dataUsuario?.user?.last_name}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Cedula de Identidad:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.ci}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Telefono:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.numero_telefono}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Direccion:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.direccion}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Email:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.user?.email || "-"}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Sexo:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.sexo || "-"}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Fecha de nacimiento:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.fecha_nacimiento_format || formatDate(dataUsuario?.fecha_nacimiento)}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Estado:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.estado || "-"}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Pertenece al complejo:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.pertenece_al_complejo_format || "-"}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Usuario tester:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.tester === "1" ? "Si" : "No"}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2">
                    <p className="text-sm font-bold text-gray-800">Fecha de registro:</p>
                    <p className="text-sm text-gray-700">{dayjs(dataUsuario?.created_at).format("DD/MM/YYYY")}</p>
                </div>
            </div>

            <div className="pt-6 mt-6 border-t border-gray-200 space-y-6">
                <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-3">Resumen</h3>
                    {dataResumen ? (
                        <div className="space-y-4 max-h-[500px] overflow-y-auto pr-1">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                                <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-3">
                                    <p className="text-xs text-gray-500">Facturas</p>
                                    <p className="text-lg font-bold text-gray-800">{formatNumber(dataResumen?.cantidad_facturas ?? dataResumen?.total_transacciones ?? 0)}</p>
                                </div>
                                <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-3">
                                    <p className="text-xs text-gray-500">Monto total</p>
                                    <p className="text-lg font-bold text-gray-800">{dataResumen?.monto_total_facturas_format || formatAmount(dataResumen?.monto_total_facturas ?? dataResumen?.total_monto, dataResumen?.currency || "Gs.")}</p>
                                </div>
                                <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-3">
                                    <p className="text-xs text-gray-500">Ticket promedio</p>
                                    <p className="text-lg font-bold text-gray-800">{dataResumen?.ticket_promedio_format || formatAmount(dataResumen?.ticket_promedio, dataResumen?.currency || "Gs.")}</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                                <div className="rounded-lg border border-gray-200 p-3 bg-white">
                                    <p className="text-sm font-semibold text-gray-800 mb-2">Actividad de compra</p>
                                    <div className="space-y-1.5 text-sm text-gray-600">
                                        <p>Primera factura: <span className="font-medium text-gray-800">{dataResumen?.primera_factura_fecha_format || formatDate(dataResumen?.primera_factura_fecha)}</span></p>
                                        <p>Ultima factura: <span className="font-medium text-gray-800">{dataResumen?.ultima_factura_fecha_format || formatDate(dataResumen?.ultima_factura_fecha)}</span></p>
                                        <p>Dias desde ultima compra: <span className="font-medium text-gray-800">{formatNumber(dataResumen?.dias_desde_ultima_factura)}</span></p>
                                        <p>Ultimo movimiento: <span className="font-medium text-gray-800">{dataResumen?.ultimo_movimiento_at_format || formatDate(dataResumen?.ultimo_movimiento_at)}</span></p>
                                        <p>Procesado: <span className="font-medium text-gray-800">{dataResumen?.fecha_ultimo_procesamiento_format || formatDateTime(dataResumen?.fecha_ultimo_procesamiento)}</span></p>
                                    </div>
                                </div>

                                <div className="rounded-lg border border-gray-200 p-3 bg-white">
                                    <p className="text-sm font-semibold text-gray-800 mb-2">Preferencias del cliente</p>
                                    <div className="space-y-1.5 text-sm text-gray-600">
                                        <p>Estado cliente: <span className="font-medium text-gray-800 capitalize">{dataResumen?.estado_cliente || "-"}</span></p>
                                        <p>Locales distintos: <span className="font-medium text-gray-800">{formatNumber(dataResumen?.cantidad_locales_distintos)}</span></p>
                                        <p>Categorias distintas: <span className="font-medium text-gray-800">{formatNumber(dataResumen?.cantidad_categorias_distintas)}</span></p>
                                        <p>Local favorito: <span className="font-medium text-gray-800">{dataResumen?.local_favorito?.nombre_fantasia || "-"} ({dataResumen?.local_favorito_nombre || dataResumen?.local_favorito?.nombre_fantasia || "-"})</span></p>
                                        <p>Categoria favorita: <span className="font-medium text-gray-800">{dataResumen?.categoria_favorita_nombre || dataResumen?.local_favorito?.nombre_categoria || "-"}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <EmptyState message="No hay resumen para mostrar." />
                    )}
                </div>

             

                <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-3">Transacciones</h3>
                    {transacciones.length === 0 ? (
                        <EmptyState message="No hay transacciones para mostrar." />
                    ) : (
                        <div className="space-y-2 max-h-[370px] overflow-y-auto pr-1">
                            {transacciones.map((item, index) => {
                                const responseData = parseJsonSafe(item?.response_data);
                                const confirmation = responseData?.confirmation || {};

                                return (
                                    <div key={`${item?.id || index}-${index}`} className="rounded-lg border border-gray-200 bg-[#f8fafc] p-3">
                                        <p className="text-sm font-semibold text-gray-800">
                                            Transaccion #{item?.id || "-"}
                                        </p>
                                        <p className="text-sm text-gray-600">Monto: {formatAmount(item?.amount, item?.currency)}</p>
                                        <p className="text-sm text-gray-600">Estado: {item?.status || "-"}</p>
                                        <p className="text-sm text-gray-600">Tipo: {item?.subject || "-"}</p>
                                        <p className="text-sm text-gray-600">Codigo respuesta: {confirmation?.response_code || "-"}</p>
                                        <p className="text-sm text-gray-600">Descripcion: {confirmation?.response_description || confirmation?.response_details || "-"}</p>
                                        <p className="text-sm text-gray-600">Nro. autorizacion: {confirmation?.authorization_number || "-"}</p>
                                        <p className="text-sm text-gray-600">Nro. ticket: {confirmation?.ticket_number || "-"}</p>
                                        <p className="text-sm text-gray-600">Fecha: {formatDate(item?.created_at)}</p>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>



                <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-3">Cupones en sorteos</h3>
                    {cuponesSorteos.length === 0 ? (
                        <EmptyState message="No hay cupones de sorteos para mostrar." />
                    ) : (
                        <div className="space-y-2 max-h-[370px] overflow-y-auto pr-1">
                            {cuponesSorteos.map((item, index) => (
                                <div key={`${item?.sorteo_id || index}-${index}`} className="rounded-lg border border-gray-200 bg-[#f8fafc] p-3">
                                    <p className="text-sm font-semibold text-gray-800">{item?.titulo || "-"}</p>
                                    <p className="text-sm text-gray-600">Cupones: {item?.cupones || "0"}</p>
                                    <p className="text-sm text-gray-600">Vigencia: {item?.vigencia_promocion_hasta_format || "-"}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-3">Giftcards compradas</h3>
                    {giftcardsCompradas.length === 0 ? (
                        <EmptyState message="No hay giftcards compradas." />
                    ) : (
                        <div className="space-y-2 max-h-[370px] overflow-y-auto pr-1">
                            {giftcardsCompradas.map((item, index) => (
                                <div key={`${item?.codigo_giftcard || index}-${index}`} className="rounded-lg border border-gray-200 bg-[#f8fafc] p-3">
                                    <p className="text-sm text-gray-700">Codigo: <span className="font-semibold">{item?.codigo_giftcard || "-"}</span></p>
                                    <p className="text-sm text-gray-700">Monto: <span className="font-semibold">{item?.valor_compra_format || "-"}</span></p>
                                    <p className="text-sm text-gray-700">Fecha: <span className="font-semibold">{item?.fecha_compra_format || "-"}</span></p>
                                    <p className="text-sm text-gray-700">Ticket: <span className="font-semibold">{item?.ticket_number || "-"}</span></p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-3">Giftcards recibidas</h3>
                    {giftcardsRecibidas.length === 0 ? (
                        <EmptyState message="No hay giftcards recibidas." />
                    ) : (
                        <div className="space-y-2 max-h-[370px] overflow-y-auto pr-1">
                            {giftcardsRecibidas.map((item, index) => (
                                <div key={`${item?.codigo_giftcard || index}-${index}`} className="rounded-lg border border-gray-200 bg-[#f8fafc] p-3">
                                    <p className="text-sm text-gray-700">Codigo: <span className="font-semibold">{item?.codigo_giftcard || "-"}</span></p>
                                    <p className="text-sm text-gray-700">Saldo: <span className="font-semibold">{item?.saldo_format || "-"}</span></p>
                                    <p className="text-sm text-gray-700">Fecha asignacion: <span className="font-semibold">{item?.fecha_asignacion_format || "-"}</span></p>
                                    <p className="text-sm text-gray-700">Comprador: <span className="font-semibold">{`${item?.first_name || ""} ${item?.last_name || ""}`.trim() || "-"}</span></p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>






                {/* GiftCards canjes */}
                <div className="mt-6 pt-6 border-t border-gray-200">
                    <h3 className="text-sm font-bold text-gray-800 mb-3">
                        Canjes de giftcards
                        {dataGiftCard?.total > 0 && (
                            <span className="ml-2 text-xs font-normal text-gray-500">
                                ({dataGiftCard?.total} total)
                            </span>
                        )}
                    </h3>
                    {giftcardsCanjes.length === 0 ? (
                        <EmptyState message="No hay canjes de giftcards para este local." />
                    ) : (
                        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead className="bg-gray-50 border-b border-gray-200">
                                        <tr>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">RUC</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha canje</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {giftcardsCanjes.map((item, index) => (
                                            <tr key={`${item?.id || item?.codigo_giftcard || index}-${index}`} className="hover:bg-gray-50 transition-colors">
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                                                    {item?.nombre_fantasia || "-"}
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.ruc || "-"}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.gift_card_compra_id || "-"}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.monto_canjeado_format || "-"}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.fecha_canje_format || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {dataGiftCard?.total > 0 && (
                                <div className="px-4 py-3 border-t border-gray-200 bg-gray-50">
                                    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                                        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
                                            <div className="text-sm text-gray-700">
                                                Mostrando <span className="font-medium">{((dataGiftCard?.current_page - 1) * dataGiftCard?.per_page) + 1}</span> a{" "}
                                                <span className="font-medium">
                                                    {Math.min(dataGiftCard?.current_page * dataGiftCard?.per_page, dataGiftCard?.total)}
                                                </span> de{" "}
                                                <span className="font-medium">{dataGiftCard?.total}</span> canjes
                                            </div>

                                            <div className="flex items-center gap-2">
                                                <span className="text-sm text-gray-600">Mostrar:</span>
                                                <select
                                                    value={perPage}
                                                    onChange={(e) => onPerPageChange && onPerPageChange(Number(e.target.value))}
                                                    className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                                <span className="text-sm text-gray-600">por página</span>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
                                            <div className="text-sm text-gray-700">
                                                Página <span className="font-medium">{dataGiftCard?.current_page}</span> de{" "}
                                                <span className="font-medium">{dataGiftCard?.last_page}</span>
                                            </div>

                                            <div className="flex items-center gap-2">
                                                <button
                                                    onClick={() => onPageChange && onPageChange(1)}
                                                    disabled={dataGiftCard?.current_page === 1}
                                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    Primera
                                                </button>
                                                <button
                                                    onClick={() => onPageChange && onPageChange(dataGiftCard?.current_page - 1)}
                                                    disabled={dataGiftCard?.current_page === 1}
                                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    Anterior
                                                </button>
                                                <button
                                                    onClick={() => onPageChange && onPageChange(dataGiftCard?.current_page + 1)}
                                                    disabled={dataGiftCard?.current_page === dataGiftCard?.last_page}
                                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    Siguiente
                                                </button>
                                                <button
                                                    onClick={() => onPageChange && onPageChange(dataGiftCard?.last_page)}
                                                    disabled={dataGiftCard?.current_page === dataGiftCard?.last_page}
                                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    Última
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="flex flex-wrap items-center gap-4 pt-6 mt-6 border-t border-gray-200">
                <button
                    type="button"
                    onClick={handleCancelar}
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                >
                    Volver
                </button>
            </div>
        </div>
    );
}

export default PerfilDetalleComponents;
